import { Schema } from '../../../../utils/form';

export default Schema.object({
  tipoAcessoArea: Schema.string(),
});
